import { render, staticRenderFns } from "./GrabHall.vue?vue&type=template&id=2a1e7688&scoped=true"
import script from "./GrabHall.vue?vue&type=script&lang=js"
export * from "./GrabHall.vue?vue&type=script&lang=js"
import style0 from "./GrabHall.vue?vue&type=style&index=0&id=2a1e7688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1e7688",
  null
  
)

export default component.exports